import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row starter-main" }
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "col-12" }

import { ref,defineAsyncComponent, onMounted,reactive } from 'vue'
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import table from "@/core/data/processType.json"

const pageTitle = "Process Types"

export default /*@__PURE__*/_defineComponent({
  __name: 'processTypes',
  setup(__props) {

const title = ref('Process Types List')
const data = ref([]);
const zeroConfiguration = defineAsyncComponent(() => import("@/components/commen/table/zeroConfiguration.vue"))

const addObj = ref({
    "id": 1,
    "title": ""
})
const rowData = ref({})
const modal = ref(null);
const isModalOpen = ref(false);
function handleEdit(row) {
      // Handle edit event from child component
      console.log('Edit row:', row);
      rowData.value = { ...row}
      console.log(isModalOpen.value);
      showModalById('editModal').show();
      console.log(isModalOpen.value);
      // Implement your edit logic here
    }
    function handleView(row) {
      // Handle edit event from child component
      console.log('Edit row:', row);
      rowData.value = { ...row}
      console.log(isModalOpen.value);
      showModalById('editModal').show();
      console.log(isModalOpen.value);
      // Implement your edit logic here
    }
function closeModal() {
    isModalOpen.value = true;
    setTimeout(() => {
        location.reload();
    }, 1000);
}

function handleDelete(id) {
    const index = data.value.data.findIndex(item => item.id === id);

if (index !== -1) {
    // Remove the object from the data array
    data.value.data.splice(index, 1);
    success_with_icon("Record updated successfully");
    } else {
        error_with_icon("Record didn't found");
    }
    }
function saveData()
{
    const lastId = data.value.data[data.value.data.length - 1].id;
    const newId = lastId + 1;
    addObj.value.id = newId;
    data.value.data.push(addObj);
    success_with_icon("Record added successfully")
    closeModal();
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
        backdrop.remove();
    }
}
function updateData()
{
    const updatedId = rowData.value.id;
    const updatedTitle = rowData.value.title;
    const rowIndex = data.value.data.findIndex(row => row.id === updatedId);

    if (rowIndex !== -1) {
        data.value.data[rowIndex].title = updatedTitle;

        success_with_icon("Record updated successfully");
    } else {
        error_with_icon("Record didn't found");
    }
    closeModal();
   
}
function deleteData()
{
    success_with_icon("Record deleted successfully")
}

function success_with_icon(message) {
    toast.success(message, {
        hideProgressBar: true, autoClose: 2000, theme: 'colored',
    });
}
function info_with_icon(message) {
    toast.info(message, {
        hideProgressBar: true, autoClose: 2000, theme: 'colored',
    });
}
function error_with_icon(message) {
    toast.error(message, {
        hideProgressBar: true, autoClose: 2000, theme: 'colored',
    });
}
function info_with_cancle(message) {
    toast.info(message, {
        hideProgressBar: true, autoClose: 2000, theme: 'colored',
    });
}
function closeEditModal()
{
    hideModalById('editModal').hide();
}
const hideModalById = (modalId) => {
  const hide = () => {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.remove("show");
      modal.style.display = "none";
    }
  };

  return { hide };
};

const showModalById = (modalId) => {
  const show = () => {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add("show");
      modal.style.display = "block";
    }
  };

  return { show };
};
onMounted(() => {
  data.value = JSON.parse(JSON.stringify(table));
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      title: pageTitle,
      modal: 'createNew'
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(zeroConfiguration), {
          tableObj: data.value,
          title: title.value,
          onEdit: handleEdit,
          onDelete: handleDelete,
          onView: handleView
        }, null, 8, ["tableObj", "title"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["modal fade", { 'show': isModalOpen.value }]),
      id: "createNew",
      tabindex: "-1",
      ref_key: "modal",
      ref: modal,
      role: "dialog",
      "aria-labelledby": "tooltipmodal",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Create " + _toDisplayString(pageTitle)),
            _cache[2] || (_cache[2] = _createElementVNode("button", {
              class: "btn-close py-0",
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("label", {
                class: "form-label",
                for: "validationCustom01"
              }, "Title", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "name",
                placeholder: "Title",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addObj.value.title) = $event))
              }, null, 512), [
                [_vModelText, addObj.value.title]
              ])
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _cache[4] || (_cache[4] = _createElementVNode("button", {
              class: "btn btn-secondary",
              type: "button",
              "data-bs-dismiss": "modal"
            }, "Close", -1)),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: saveData
            }, "Save changes")
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: "modal fade",
      ref_key: "modal",
      ref: modal,
      id: "editModal",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "tooltipmodal",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h3", { class: "modal-title" }, "Edit " + _toDisplayString(pageTitle)),
            _createElementVNode("button", {
              class: "btn-close py-0",
              type: "button",
              "data-bs-dismiss": "modal",
              onClick: closeEditModal,
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                class: "form-label",
                for: "validationCustom01"
              }, "Title", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "name",
                placeholder: "Title",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rowData.value.title) = $event))
              }, null, 512), [
                [_vModelText, rowData.value.title]
              ])
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              type: "button",
              onClick: closeEditModal,
              "data-bs-dismiss": "modal"
            }, "Close"),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: updateData
            }, "Save changes")
          ])
        ])
      ])
    ], 512)
  ], 64))
}
}

})